/**
 * Initializes cookie banner functionality.
 */
const initCookieBanner = function() {
  const cookie_banner = document.querySelector('.js-cookie-banner');
  const has_been_closed = window.localStorage.getItem('cookie_banner_hidden');

  if (cookie_banner && !has_been_closed) {
    cookie_banner.classList.add('cookie-banner--shown');

    // prevent on transitionend event while adding class
    setTimeout(() => {
      cookie_banner.classList.add('cookie-banner--transition');
    }, 0);

    cookie_banner.addEventListener('transitionend', e => {
      if (e.target === cookie_banner) {
        cookie_banner.parentNode.removeChild(cookie_banner);
      }
    });

    const btn_close = cookie_banner.querySelector('button');

    /**
     * Hides the cookie banner.
     */
    function close() {
        cookie_banner.classList.remove('cookie-banner--shown');
        window.localStorage.setItem('cookie_banner_hidden', true);
    }

    /**
     * Handles the scroll.
     */
    function cookieHandler() {
      close();
      window.removeEventListener('scroll', cookieHandler);
    }

    window.addEventListener('scroll', cookieHandler, {passive: true});
    window.addEventListener('click', cookieHandler);

    const skipToMain = document.getElementById('theSkip');
    btn_close.addEventListener('keydown', (e) => {
      var theCode = e.keyCode;
      switch(theCode)
      {
        //tab key
        case 9:
        close();
        e.preventDefault();
        break;
        //enter key
        case 13:
          close();
          e.preventDefault();
          break;
        //space bar
        case 32:
         close();
         break;
      }
      if (skipToMain)
       {
         skipToMain.focus();
       }
    });

    btn_close.addEventListener('click', () => {
      window.removeEventListener('scroll', cookieHandler);
      window.removeEventListener('click', cookieHandler);
      close();
    // const betaLink = document.querySelector('.beta-banner a');
    //  if (betaLink)
    //{
    //   betaLink.focus();
    //}

    });
  } else {
    cookie_banner.parentNode.removeChild(cookie_banner);
  }
};

export default initCookieBanner;

